import { render, staticRenderFns } from "./DimensionSelect.vue?vue&type=template&id=5019c935&scoped=true"
import script from "./DimensionSelect.vue?vue&type=script&lang=js"
export * from "./DimensionSelect.vue?vue&type=script&lang=js"
import style0 from "./DimensionSelect.vue?vue&type=style&index=0&id=5019c935&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019c935",
  null
  
)

export default component.exports